import React from 'react';
import {
  Home,
  Dashboard,
  School,
  Book,
  Extension,
  Architecture,
  MenuBook,
  Assignment,
  Quiz,
  VideoLibrary,
  Forum,
  People,
  Person,
  Settings,
  Notifications,
  CalendarToday,
  BarChart,
  CloudDownload,
  Help,
  Feedback,
  AccountCircle,
  Class,
  Groups,
  CalendarMonth,
  Spellcheck,
  Looks3,
  PsychologyAlt,
  Addchart,
  TableChart,
  Escalator,
  PlayArrow,
  AllInclusive,
  Summarize,
  Description,
  MarkEmailRead,
  Grading
} from '@mui/icons-material';
import { IconName } from '../../types/navigation';

interface IconProps {
  name: IconName;
  fontSize?: 'small' | 'medium' | 'large';
}

export const Icon: React.FC<IconProps> = ({ name, fontSize = 'medium' }) => {
  switch (name) {
    case 'Templates':
      return <Description fontSize={fontSize} />;
    case 'EmailLogs':
      return <MarkEmailRead fontSize={fontSize} />;      
    case 'Home':
      return <Home fontSize={fontSize} />;
    case 'Dashboard':
      return <Dashboard fontSize={fontSize} />;
    case 'School':
      return <School fontSize={fontSize} />;
    case 'Book':
      return <Book fontSize={fontSize} />;
    case 'Extension':
      return <Extension fontSize={fontSize} />;
    case 'Architecture':
      return <Architecture fontSize={fontSize} />;

    case 'Course':
    case 'Courses':
      return <MenuBook fontSize={fontSize} />;
    case 'Engage':
    case 'Discussion':
      return <Forum fontSize={fontSize} />;
    case 'MyProgram':
    case 'Program':
      return <Class fontSize={fontSize} />;
    case 'Assignment':
    case 'Assignments':
      return <Assignment fontSize={fontSize} />;
    case 'Quiz':
    case 'Quizzes':
      return <Quiz fontSize={fontSize} />;
    case 'Video':
    case 'Videos':
      return <VideoLibrary fontSize={fontSize} />;
    case 'Students':
    case 'Participants':
      return <People fontSize={fontSize} />;
    case 'Groups':
      return <Groups fontSize={fontSize} />;
    case 'Profile':
      return <Person fontSize={fontSize} />;
    case 'Account':
      return <AccountCircle fontSize={fontSize} />;
    case 'Settings':
      return <Settings fontSize={fontSize} />;
    case 'Notifications':
      return <Notifications fontSize={fontSize} />;
    case 'Analytics':
    case 'Reports':
      return <BarChart fontSize={fontSize} />;
    case 'Downloads':
      return <CloudDownload fontSize={fontSize} />;
    case 'Help':
      return <Help fontSize={fontSize} />;
    case 'Feedback':
      return <Feedback fontSize={fontSize} />;
    case 'Calendar':
      return <CalendarMonth fontSize={fontSize} />;
    case 'Spellcheck':
      return <Spellcheck fontSize={fontSize} />;
    case 'Looks3':
      return <Looks3 fontSize={fontSize} />;
    case 'PsychologyAlt':
      return <PsychologyAlt fontSize={fontSize} />;
    case 'Addchart':
      return <Addchart fontSize={fontSize} />;
    case 'TableChart':
      return <TableChart fontSize={fontSize} />;
    case 'Escalator':
      return <Escalator fontSize={fontSize} />;
    case 'PlayArrow':
      return <PlayArrow fontSize={fontSize} />;

    case 'Summarize':
      return <Summarize fontSize={fontSize} />;

    case 'AllInclusive':
      return <AllInclusive fontSize={fontSize} />;

    case 'Grading':
      return <Grading fontSize={fontSize} />;

    default:
      return null;
  }
};
